import React, { Component } from "react";
import { getBitcoinsTrade } from "../services/bitcoinsTradeService";
import auth from "../services/authService";
import Spinner from "./common/spinner";
import NotFound from "./notFound";
import moment from "moment";
import ModalImage from "react-modal-image";
import { Link } from "react-router-dom";
import axios from "axios";

class ClosedTradeInfo extends Component {
  state = {
    loading: false,
    comment: "",
    processed_by: "",
    trade_closing_date: "",
    trade_reference: "",
    trade_response: "",
    trade_type: "",
    user_email: "",
  };

  async componentDidMount() {
    const tradeId = this.props.match.params.id;

    this.setState({ loading: true });

    await axios.get(`/closed-trades/${tradeId}`).then((resp) => {
      const data = resp.data.data;
      this.setState({
        comment: data.comment,
        processed_by: data.processed_by,
        trade_closing_date: data.trade_closing_date,
        trade_reference: data.trade_reference,
        trade_response: data.trade_response,
        trade_type: data.trade_type,
        user_email: data.user_email,
      });
    });
    // console.log((await getBitcoinsTrade(tradeId)).data.data);

    this.setState({ loading: false });
  }

  getPagedData = () => {
    const { users } = this.state;

    return { data: users };
  };

  render() {
    const {
      loading,
      comment,
      processed_by,
      trade_closing_date,
      trade_reference,
      trade_response,
      trade_type,
      user_email,
    } = this.state;
    const { isAdmin } = auth.getCurrentUser();
    return isAdmin ? (
      <React.Fragment>
        {loading && <Spinner message="" />}
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold text-primary">
              {trade_reference}
            </h6>
          </div>

          <div className="card-body">Processed by: {processed_by}</div>
          <div className="card-body">Closing Date: {trade_closing_date}</div>
          <div className="card-body">Comment: {comment}</div>
          <div className="card-body">User Email: {user_email}</div>
          <div className="card-body">
            Trade Response: {trade_response && trade_response.name}
          </div>
          <div className="card-body">
            Trade Type: {trade_type && trade_type.name}
          </div>
          <div className="card-body">Trade Ref: {trade_reference}</div>
        </div>
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default ClosedTradeInfo;
